import { render } from "./Postback.vue?vue&type=template&id=305f51a2&ts=true&lang=pug"
import script from "./Postback.vue?vue&type=script&lang=ts"
export * from "./Postback.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__